module.exports = __webpack_public_path__ + "static/media/WhitespaceGoodOptimized.6d835929.png";